import React, { useEffect, useState } from 'react';
import { post } from '../Auths/AuthToken';
import { useNavigate, useParams } from 'react-router-dom';
import setUiMessage from '../../Utilities/Tostify';
import DemographicsPopup from './DemographicsPopup';
import TratPlaDemo from './TratPlaDemo';
import RenderMatCounsellingData from './soapNoteTemplateData/RenderMatCounsellingData';
import MatCounselingPopup from './MatCounselingPopup';
import GoalPlanPupup from './GoalPlanPupup';
import RenderGoalPlanData from './soapNoteTemplateData/RenderGoalPlanData';
import ConfirmDialog from '../../Utilities/ConfirmDialog';
import { DEFAULT_LOCAL_PATH } from '../../constents';
import PatVisitRightSidebar from './PatVisitRightSidebar';
import PatientSignPopup from './PatientSignPopup';
import ReactDOMServer from 'react-dom/server';
import TreatmentPlanPrintPopUp from './TreatmentPlanPrintPopUp';
import PrintLayout from '../Layouts/PrintLayout';
import { useSelector } from 'react-redux';

function TreatPlanNoteEdit({ handleReloadCf }) {
  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const { patientId, appId, visitId, treatmentId } = useParams();
  const [allData, setAllData] = useState(false);
  //const [appointmentId, setAppointmentId] = useState(appId);
  const [demographicsPopup, setDemographicsPopup] = useState(false);
  const [matCounsclPopup, setMatCounsclPopup] = useState(false);
  const [addNewGalPopup, setAddNewGalPopup] = useState(false);
  const [goalId, setGoalId] = useState('');
  const [goalNo, setGoalNo] = useState(1);
  const [eitableMode, setEitableMode] = useState(true);
  const [signAndDone, setSignAndDone] = useState(false);

  const [demoData, setDemoData] = useState(false);
  const [treatPlanData, setTreatPlanData] = useState(false);
  const [goalData, setGoalData] = useState(false);

  const [resSetStatus, setResSetStatus] = useState(false);

  const [deleteGoalPlan, setDeleteGoalPlan] = useState(false);
  const [sucPrams, setSucPrams] = useState('');
  const [patSignPopup, setPatSignPopup] = useState(false);

  const [headerFooterInfo, setHeaderFooterInfo] = useState('');

  useEffect(() => {
    (async () => {
      try {
        if (patientId && appId) {
          const response = await post(
            'api/patient/treatmentPlan/patientTreatmentPlan',
            {
              patientId: patientId,
              appointmentId: appId,
              visitId: visitId,
              treatmentId: treatmentId,
            },
          );
          if (response.status === 200) {
            setAllData(response?.data);
            setDemoData(response?.data?.demographics);
            setTreatPlanData(response?.data?.treatmentData);
            setGoalData(response?.data?.goalData);
            setHeaderFooterInfo(response?.data?.printHeaderFooterInfo);
            setResSetStatus(response?.data?.result_set?.status);
            setGoalNo(
              response?.data?.goalData
                ? response?.data?.goalData.length + 1
                : 1,
            );
            if (response?.data?.result_set?.status === '1') {
              setMatCounsclPopup(true);
              setEitableMode(true);
            } else if (response?.data?.result_set?.status === '3') {
              setEitableMode(true);
              setSignAndDone(true);
            } else if (response?.data?.result_set?.status === '2') {
              setSignAndDone(true);
            } else {
              //setEitableMode(false);
            }
            if (response?.data?.result_set?.reviewed === '1') {
              setEitableMode(false);
            }
          }
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  }, [patientId, appId, visitId, treatmentId]);

  const handleChangeAppStatus = async (
    appId,
    appStatus,
    currentStatusAutoIncId,
    patientId,
  ) => {
    try {
      const response = await post(
        'api/appointment/Appointment/changeCurrentStatus',
        {
          appointmentId: appId,
          currentStatusId: parseInt(appStatus) === 16 ? 7 : appStatus,
          currentStatusAutoIncId: currentStatusAutoIncId,
          patient_id: patientId,
          loginUserId: user?.id,
          recurringVal: 0,
          reason: '',
        },
      );
      if (response?.status === 200) {
        if (response?.data?.successCode === 1) {
          setUiMessage('suc', 'Appointment status change successfully.');
        } else {
          setUiMessage('inf', 'Unable to change appointment status.');
        }
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };
  const handleTreatmentEdit = (visitId, appId, treatmentId) => {
    //setAppointmentId(appId);
    navigate(
      `${DEFAULT_LOCAL_PATH}/patient/treatPlan/${patientId}/${appId}/${visitId}/${treatmentId}`,
    );
  };

  const addTreatmentGoal = (goalId, goalNo) => {
    setAddNewGalPopup(true);
    setGoalId(goalId);
    setGoalNo(goalNo + 1);
  };

  const handleTempletDeleteConfirm = async (goalId) => {
    if (allData?.treatmentId && goalId) {
      try {
        const response = await post('api/patient/treatmentPlan/deleteGoal', {
          treatmentId: allData?.treatmentId,
          goalId: goalId,
          staffUserId: user?.id,
        });
        if (response?.status === 200) {
          handleReloadAfterSave('goal');
          setDeleteGoalPlan(false);
          //setProviderSig(true);
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    }
  };

  const deleteTreatmentGoal = async (goalId, goalNo) => {
    setDeleteGoalPlan(true);
    setSucPrams(goalId);
  };

  const handleGolePlanDone = async () => {
    if (goalData) {
      setEitableMode(false);
      setSignAndDone(!signAndDone);
      if (allData?.reviewExist === '1') {
        try {
          const response = await post(
            'api/patient/TreatmentPlan/updateReference',
            {
              treatmentId: allData?.treatmentId,
            },
          );
          if (response?.status === 200) {
          }
        } catch (err) {
          setUiMessage('err', err.message);
        }
      }
    } else {
      setUiMessage('err', 'Please add goal data.');
    }
  };

  const handleReviewAndChange = () => {
    setEitableMode(true);
    setSignAndDone(!signAndDone);
  };

  const handlProviderSignature = async (treatmentId) => {
    handleSaveAndSine(treatmentId);
  };
  const handleSignAndDone = (treatmentId) => {
    if (goalData) {
      setSignAndDone(false);
      setEitableMode(false);
      handleSaveAndSine(treatmentId);
    } else {
      setUiMessage('err', 'Please add goal data.');
    }
  };

  const handleSaveAndSine = async (treatmentId) => {
    if (treatmentId) {
      try {
        const response = await post(
          'api/patient/treatmentPlan/saveSignInDate',
          {
            treatmentId: treatmentId,
            staffUserId: user?.id,
            appId: appId,
          },
        );
        if (response?.status === 200) {
          //handleReload();
          handleReloadAfterSave('demo');
          //setSignAndDone(true);
          //setProviderSig(true);
          handleChangeAppStatus(
            appId,
            response?.data?.currentStatusId,
            response?.data?.currentStatusAutoIncId,
            patientId,
          );
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    }
  };
  const handlPatientSignature = async (treatmentId) => {
    setPatSignPopup(true);
    // if (treatmentId) {
    //   try {
    //     const response = await post(
    //       'api/patient/treatmentPlan/savePatSignInDate',
    //       {
    //         patientId: patientId,
    //         treatmentId: treatmentId,
    //         staffUserId: user?.id,
    //       }
    //     );
    //     if (response?.status === 200) {
    //       handleReloadAfterSave('demo');
    //     }
    //   } catch (err) {
    //     setUiMessage('err', err.message);
    //   }
    // }
  };

  const handleReloadAfterSave = async (type) => {
    const response = await post(
      'api/patient/treatmentPlan/patientTreatmentPlan',
      {
        patientId: patientId,
        appointmentId: appId,
        visitId: visitId,
        treatmentId: treatmentId,
      },
    );
    if (response.status === 200) {
      setAllData(response?.data);
      setResSetStatus(response?.data?.result_set?.status);
      if (type === 'demo') {
        setDemoData(response?.data?.demographics);
      } else if (type === 'treat') {
        setTreatPlanData(response?.data?.treatmentData);
        setSignAndDone(true);
      } else if (type === 'goal') {
        setGoalData(response?.data?.goalData);
      } else if (type === 'both') {
        setTreatPlanData(response?.data?.treatmentData);
        setSignAndDone(true);
        setGoalData(response?.data?.goalData);
      }
    }
  };

  const handleCancelReview = async (treatmentId) => {
    const response = await post('api/patient/treatmentPlan/cancelReviewCopy', {
      treatmentId: treatmentId,
    });
    if (response.status === 200) {
      setUiMessage('suc', 'Review has been calnceled.');

      handleTreatmentEdit(
        visitId,
        appId,
        response?.data?.reviewTreatmentCopy?.id,
      );
      //setReload(!reload);
      //handleReloadAfterSave('demo');
    }
  };

  const handlePrint = () => {
    // setAllData(response?.data);
    const newWindow = window.open('', '_blank', 'height=700,width=900');
    if (newWindow) {
      const printContent = ReactDOMServer.renderToString(
        <PrintLayout headerFooterInfo={headerFooterInfo}>
          <TreatmentPlanPrintPopUp
            allData={allData}
            demoData={demoData}
            genData={treatPlanData}
          />
        </PrintLayout>,
      );
      newWindow.document.write(printContent);
      newWindow.document.close();
      setTimeout(() => {
        newWindow.print();
      }, 0);
    } else {
      setUiMessage(
        'war',
        'Popup blocked! Please allow popups for this website.',
      );
    }
  };

  return (
    <div className="chart-right-col-mid-bdy">
      <div className="c-mid-bdy-edit-blk">
        <div className="dos-blk">
          <div className="t-plan-hdr">
            <span className="bold">DOS</span>
            <input
              type="search"
              className="main-search"
              placeholder="Search date..."
            />
          </div>
          <div className="t-plan-bdy">
            {allData?.visitList &&
              allData?.visitList.map((data, i) => (
                <div
                  key={i}
                  className={
                    data?.treatmentId === treatmentId
                      ? 't-plan-bdy-rw councel-note-active-dos'
                      : i % 2 === 0
                        ? 't-plan-bdy-rw'
                        : 't-plan-bdy-rw alt-rw'
                  }
                  onClick={() =>
                    handleTreatmentEdit(
                      data?.visit_id,
                      data?.appointment_id,
                      data?.treatmentId,
                    )
                  }
                >
                  <span className="fontsize15">{data?.visType}</span>
                  <span className="fontsize13">{data?.dateAdded}</span>
                  <span className="fontsize13">{data?.resName}</span>
                </div>
              ))}
          </div>
        </div>
        <div className="template-blk treatment-block-main">
          <div className={'sectionBlock smart-tag-sec'}>
            <div className="smart-tag-add-rem">
              {eitableMode ? (
                <span
                  className="smart-tag-name"
                  onClick={() => setDemographicsPopup(true)}
                >
                  Demographics
                </span>
              ) : (
                <span>Demographics</span>
              )}
            </div>
            <TratPlaDemo demodata={demoData} />
          </div>
          <div className={'sectionBlock smart-tag-sec'}>
            <div className="smart-tag-add-rem">
              {eitableMode ? (
                <span
                  className="smart-tag-name"
                  onClick={() => setMatCounsclPopup(true)}
                >
                  Treatment Plan
                </span>
              ) : (
                <span>Treatment Plan</span>
              )}
            </div>
            <RenderMatCounsellingData data={treatPlanData} />
          </div>
          <div className={'sectionBlock smart-tag-sec'}>
            <div
              className="smart-tag-add-rem"
              style={{ display: 'flex', qjustifyContent: 'space-between' }}
            >
              <span className="smart-tag-name">{''}</span>
              {eitableMode && (
                <span
                  className="smart-tag-name"
                  onClick={() => {
                    setAddNewGalPopup(true);
                    setGoalNo((goalData && goalData.length) + 1);
                  }}
                >
                  Add new goal
                </span>
              )}
            </div>
            <RenderGoalPlanData
              data={goalData}
              addTreatmentGoal={addTreatmentGoal}
              deleteTreatmentGoal={deleteTreatmentGoal}
              eitableMode={eitableMode}
              resSetStatus={resSetStatus}
              reviewExist={allData?.reviewExist}
            />
          </div>
          <div dangerouslySetInnerHTML={{ __html: allData?.getSignStr }} />
          <div className="gnrl-dtl-btn-rw">
            <>
              {(() => {
                if (allData?.result_set?.reviewed === '1') {
                  return (
                    <button
                      className="actn-yes"
                      style={{ width: 'unset' }}
                      onClick={handlePrint}
                    >
                      Print
                    </button>
                  );
                } else {
                  if (resSetStatus === '1') {
                    // return (
                    //   <button
                    //     className="actn-yes"
                    //     style={{ width: 'unset' }}
                    //     onClick={null}
                    //   >
                    //     Done
                    //   </button>
                    // );
                  } else if (resSetStatus === '2') {
                    if (signAndDone) {
                      return (
                        <>
                          <button
                            className="actn-yes"
                            style={{ width: 'unset' }}
                            onClick={handleGolePlanDone}
                          >
                            Sign later
                          </button>
                          {allData?.resourceId === user.id && (
                            <button
                              className="actn-yes"
                              style={{ width: 'unset' }}
                              onClick={() =>
                                handleSignAndDone(allData?.treatmentId)
                              }
                            >
                              Sign
                            </button>
                          )}
                          {allData?.cosign_result_set?.co_signin_by ===
                            user.id &&
                          allData?.cosign_result_set?.co_signin_status ===
                            '0' &&
                          allData?.resourceId !==
                            allData?.cosign_result_set?.co_signin_by ? (
                            <button
                              className="actn-yes"
                              style={{ width: 'unset' }}
                              onClick={() =>
                                handleSignAndDone(allData?.treatmentId)
                              }
                            >
                              Co-Sign
                            </button>
                          ) : (
                            ''
                          )}
                          {allData?.reviewExist === '1' && (
                            <button
                              className="actn-yes"
                              style={{ width: 'unset' }}
                              onClick={() =>
                                handleCancelReview(allData?.treatmentId)
                              }
                            >
                              Discard review
                            </button>
                          )}
                        </>
                      );
                    } else {
                      return (
                        <>
                          <button
                            className={'actn-yes'}
                            style={{ width: 'unset' }}
                            onClick={() =>
                              handlProviderSignature(allData?.treatmentId)
                            }
                          >
                            Provider’s signature
                          </button>
                          {!parseInt(allData?.result_set?.patient_sign_by) && (
                            <button
                              className={'actn-yes'}
                              style={{ width: 'unset' }}
                              onClick={() =>
                                handlPatientSignature(allData?.treatmentId)
                              }
                            >
                              Patient's signature
                            </button>
                          )}
                          {!parseInt(allData?.result_set?.patient_sign_by) &&
                          !parseInt(allData?.result_set?.signin_by) ? (
                            <button
                              className="actn-yes"
                              style={{ width: 'unset' }}
                              onClick={handleReviewAndChange}
                            >
                              Change
                            </button>
                          ) : (
                            ''
                          )}
                          <button className="actn-yes" onClick={handlePrint}>
                            Print
                          </button>
                        </>
                      );
                    }
                  } else if (resSetStatus === '3') {
                    return (
                      <>
                        {(!parseInt(allData?.result_set?.patient_sign_by) && (
                          <button
                            className={'actn-yes'}
                            style={{ width: 'unset' }}
                            onClick={() =>
                              handlPatientSignature(allData?.treatmentId)
                            }
                          >
                            Patient's signature
                          </button>
                        )) ||
                          (parseInt(allData?.result_set?.patient_sign_by) && (
                            <>
                              <button
                                className={
                                  signAndDone ? 'actn-yes hide' : 'actn-yes'
                                }
                                style={{ width: 'unset' }}
                                onClick={handleReviewAndChange}
                              >
                                Review treatment plan
                              </button>
                              {/* <button
                                className={
                                  signAndDone ? 'actn-yes' : 'actn-yes hide'
                                }
                                style={{ width: 'unset' }}
                                onClick={handleGolePlanDone}
                              >
                                Cancel
                              </button> */}
                            </>
                          ))}
                        <button className="actn-yes" onClick={handlePrint}>
                          Print
                        </button>
                      </>
                    );
                  }
                }
              })()}
            </>
          </div>
        </div>
      </div>
      <div className="chart-right-section">
        <PatVisitRightSidebar
          appId={appId}
          headerData={allData?.hearderDetail}
          patientId={patientId}
        />
      </div>
      {demographicsPopup && (
        <DemographicsPopup
          handleClose={() => setDemographicsPopup(false)}
          patientId={patientId}
          handleReload={handleReloadAfterSave}
        />
      )}
      {matCounsclPopup && (
        <MatCounselingPopup
          handleClose={() => setMatCounsclPopup(false)}
          handleReload={handleReloadAfterSave}
          treatmentId={allData?.treatmentId}
          patientId={patientId}
          appId={appId}
          visitId={visitId}
        />
      )}
      {addNewGalPopup && (
        <GoalPlanPupup
          handleClose={() => {
            setAddNewGalPopup(false);
            setGoalId('');
          }}
          handleReload={handleReloadAfterSave}
          treatmentId={allData?.treatmentId}
          goalId={goalId}
          goalNo={goalNo}
          goalstatus={resSetStatus}
        />
      )}
      {deleteGoalPlan && (
        <ConfirmDialog
          bodytext={'Do you want to remove it?'}
          closeDialog={() => setDeleteGoalPlan(false)}
          successDialog={handleTempletDeleteConfirm}
          sucPrams={sucPrams}
        />
      )}
      {patSignPopup && (
        <PatientSignPopup
          handlePrint={handlePrint}
          handleClose={() => setPatSignPopup(false)}
          patientId={patientId}
          treatmentId={allData?.treatmentId}
          handleReload={() => handleReloadAfterSave('demo')}
        />
      )}
    </div>
  );
}

export default TreatPlanNoteEdit;
